import React, { Component } from "react";
import "./SocialLogin.scss";
import { ReactComponent as FacebbokIcon } from "../../../assets/svg/facebook-login.svg";

import { ReactComponent as LinkedinIcon } from "../../../assets/svg/linkedin-login.svg";
import { ReactComponent as MicrosoftIcon } from "../../../assets/svg/microsoft.svg";
import { Link, Redirect } from "react-router-dom";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
// import GoogleLogin from "react-google-login";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { facebookLogin, linkedinLogin, googleLogin, signUp } from "../../../actions/authAction";
import moment from "moment";
import MicrosoftLoginModal from "./MicrosoftLoginModal";
import GmailLogin from "./GmailLogin";
import { isMobile } from "react-device-detect";

class SocialLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            microsoftPopupModal: false,
        };
    }
    componentDidMount() {
        if (window.FB) {
            window.FB.init({
                version: "v12.0",
                appId: process.env.REACT_APP_FB_APP_ID,
                xfbml: "false",
                cookie: "false",
            });
        }
    }
    socialresponse(response) {
        if (response.accessToken) {
            const param = {};
            param["auth_code"] = response.accessToken;
            param["platform"] = "facebook";
            this.props.facebookLogin(param);
        } else {
            toast.error("Error in authorizing.Please try again");
        }
    }
    // responseGoogle(response) {
    //     console.log("firstresponse",response.code)
    //     // if (response.code) {
    //         let param = {};
    //         param["auth_code"] = response.code;
    //         param["platform"] = "google";
    //         param["redirect_url"] = window.location.origin;
    //         this.props.googleLogin(param);
    //     // }

    //     // else if (response.error) {
    //     //     if (response.error == "idpiframe_initialization_failed") {
    //     //         console.log("Login with google is not available in incognito mode");
    //     //     } else {
    //     //         toast.error("Error in authorizing.Please try again");
    //     //     }
    //     // } else {
    //     //     console.log(response);
    //     //     toast.error("Error in authorizing.Please try again");
    //     // }
    // }
    onAutoLoad(resp) {}
    redirectToLinkedin = () => {
        const unique_identifier = moment.now();
        window.location.href =
            `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=` +
            window.location.origin +
            "/oauth-linkedin&state=" +
            unique_identifier +
            "&scope=r_emailaddress,r_basicprofile";
        //    let redirect__url= "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=81p4scwoytpfl7&redirect_uri=" +
        //         window.location.origin +
        //         "/oauth-linkedin&state=" +
        //         cmp_identifier +
        //         "&scope=r_emailaddress,r_basicprofile"
        //         let width = 450,
        //         height = 730,
        //         left = window.screen.width / 2 - width / 2,
        //         top = window.screen.height / 2 - height / 2;

        //       window.open(
        //         redirect__url,
        //         "Linkedin",
        //         "menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=" +
        //           width +
        //           ", height=" +
        //           height +
        //           ", top=" +
        //           top +
        //           ", left=" +
        //           left
        //       )
    };
    MicrosoftRedirect = () => {
        // window.location.href = "https://api2.radarr.com/azure?tenantId=0cbd9e16-4a51-46bb-a891-42a04f76de27";
    };
    closeModal = () => {
        this.setState({ microsoftPopupModal: false });
    };

    authType = () => {
        return this.props.routeTo.substring(1) === "signup" ? "Sign in" : "Sign up";
    };

    render() {
        return (
            <div className="socialLogin">
                <p className="block__separator">(Or)</p>
                <p className="social_msg">
                    <span>{this.authType()}</span> with Social Account
                </p>
                <div className="social__icon-block">
                    <GmailLogin googleLogin={this.props.googleLogin} authType={this.authType()} />
                    {/* <GoogleLogin
                        clientId="626488198253-v37qlu0s8mc6qt43jj6u2k1asfqfvu7e.apps.googleusercontent.com"
                        autoLoad={false}
                        onSuccess={(response) => this.responseGoogle(response)}
                        onFailure={(response) => this.responseGoogle(response)}
                        onAutoLoadFinished={(response) => {
                            this.onAutoLoad(response);
                        }}
                        scope="profile email"
                        isSignedIn={false}
                        responseType="code"
                        cookiePolicy={"single_host_origin"}
                        render={(renderProps) => (
                            <span className="icon-wrap" onClick={renderProps.onClick}>
                                <GoogleIcon title="Login with Google" />
                                <span className="fix__align">Google</span>
                            </span>
                        )}
                    /> */}

                    {/* <FacebookLogin
                        appId="380160882053295"
                        version="12.0"
                        fields="name,email,picture"
                        authType="reauthenticate"
                        scope="public_profile,email"
                        callback={(response) => this.socialresponse(response)}
                        render={(renderProps) => (
                            <span onClick={renderProps.onClick} className="icon-wrap">
                                <FacebbokIcon title="Login with Facebook" />
                                <span className="auth_text">{this.authType()} with Facebook</span>
                            </span>
                        )}
                    /> */}
                    <span className="icon-wrap " onClick={() => this.redirectToLinkedin()}>
                        <LinkedinIcon title="Login with Linkedin" className="fix__height" />
                        <span className="auth_text">{this.authType()} with LinkedIn</span>
                    </span>
                    {this.props.routeTo.substring(1) !== "signup" && !isMobile ? (
                        <FacebookLogin
                            appId={process.env.REACT_APP_FB_APP_ID}
                            version="12.0"
                            fields="name,email,picture"
                            authType="reauthenticate"
                            scope="public_profile,email"
                            callback={(response) => this.socialresponse(response)}
                            render={(renderProps) => (
                                <span onClick={renderProps.onClick} className="icon-wrap linkedin__login">
                                    <FacebbokIcon title="Login with Facebook" />
                                    <span className="auth_text">{this.authType()} with Facebook</span>
                                </span>
                            )}
                        />
                    ) : // <span className="icon-wrap linkedin__login" onClick={() => this.redirectToLinkedin()}>
                    //     <LinkedinIcon title="Login with Linkedin" />
                    //     <span className="auth_text">{this.authType()} with LinkedIn</span>
                    // </span>
                    null}
                </div>
                {this.props.routeTo.substring(1) === "signup" ? (
                    <div className="signup__content">
                        {!isMobile ? (
                            <FacebookLogin
                                appId={process.env.REACT_APP_FB_APP_ID}
                                version="12.0"
                                fields="name,email,picture"
                                authType="reauthenticate"
                                scope="public_profile,email"
                                callback={(response) => this.socialresponse(response)}
                                render={(renderProps) => (
                                    <span onClick={renderProps.onClick} className="icon-wrap">
                                        <FacebbokIcon title="Login with Facebook" />
                                        <span className="auth_text">{this.authType()} with Facebook</span>
                                    </span>
                                )}
                            />
                        ) : null}
                        {/* <span className="icon-wrap" onClick={() => this.redirectToLinkedin()}>
                            <LinkedinIcon title="Login with Linkedin" className="fix__height" />
                            <span className="auth_text">{this.authType()} with LinkedIn</span>
                        </span> */}
                        <span className={`icon-wrap ${isMobile ? "mobile-version" : null}`} onClick={() => this.setState({ microsoftPopupModal: true })}>
                            <MicrosoftIcon title="Login with Microsoft" />
                            <span className="auth_text">{this.authType()} with Microsoft</span>
                        </span>
                    </div>
                ) : null}

                {!this.props.wlSignIn && (
                    <div className="sign__up">
                        {/* {this.props.routeTo.substring(1) === "signup" && <span> Don&apos;t have an account?</span>}
                        {this.props.routeTo.substring(1) === "signin" && <span> Already have an account?</span>}{" "}
                        <Link to={this.props.routeTo} className="signup__text">
                            <span>{this.props.routeTo.substring(1) === "signup" ? "Sign Up" : "Sign In"}</span>
                        </Link> */}
                    </div>
                )}
                {this.props.facebookLogedIn && <Redirect to="/home" />}
                {this.props.googleLogedIn && <Redirect to="/home" />}
                {this.props.showGettingStarted && this.props.facebookLogedIn && <Redirect to="/gettingStarted" />}
                {this.props.showGettingStarted && this.props.googleLogedIn && <Redirect to="/gettingStarted" />}
                {this.state.microsoftPopupModal ? <MicrosoftLoginModal open={this.state.microsoftPopupModal} closeModal={this.closeModal} /> : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        facebookLogedIn: state.authReducer.facebookLogedIn,
        googleLogedIn: state.authReducer.googleLogedIn,
        showGettingStarted: state.globalReducer.showGettingStarted,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        facebookLogin: (params) => dispatch(facebookLogin(params)),
        linkedinLogin: (params) => dispatch(linkedinLogin(params)),
        googleLogin: (params) => dispatch(googleLogin(params)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocialLogin);
